import { type FC } from 'react'
import { type UseFormReturn } from 'react-hook-form'
import { FormattedMessage } from 'react-intl'

import { Heading } from 'base-ui'

import { type MarketplacePartnerRegisterPageFormV3Values } from '../../../hooks/marketplacePartnerRegisterPageFormV3RHFModel'

import { MarketplacePartnerRegisterPageFormV3InputField } from './MarketplacePartnerRegisterPageFormV3InputField'

type MarketplacePartnerRegisterPageFormV3CustomMessageProps = {
  form: UseFormReturn<MarketplacePartnerRegisterPageFormV3Values>
}

export const MarketplacePartnerRegisterPageFormV3CustomMessage: FC<
  MarketplacePartnerRegisterPageFormV3CustomMessageProps
> = ({ form }) => {
  return (
    <div className="flex flex-col gap-10">
      <Heading level={2} size="l">
        <FormattedMessage id="marketplacePartnerRegisterPage.customMessage.title" />
      </Heading>
      <MarketplacePartnerRegisterPageFormV3InputField
        fieldName="description"
        form={form}
        label={
          <FormattedMessage id="marketplacePartnerRegisterPage.customMessage.label" />
        }
        type="textarea"
      />
    </div>
  )
}
